import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import MainLayout from 'components/layout/MainLayout';
import PlainLoadingSpinner from 'components/PlainLoadingSpinner';
import { useAuthRedirectEffect } from 'hooks/account/useAuthRedirect';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';
import { runningLocally } from 'utils/constants';

const DesignSystemWrapper = observer((props: { children: ReactNode }) => {
  const userStore = useUserStore();
  const router = useRouter();
  const isFullPagePreview = ['/design-system/order-confirmation'].includes(
    router.pathname,
  );
  const isDesignSystemIndex = router.pathname === '/design-system';

  if (!runningLocally) {
    useAuthRedirectEffect('/design-system');
  }
  if (!runningLocally) {
    if (userStore.userInitialized) {
      if (
        !(
          userStore.currentUser?.role === 'ADMIN' ||
          userStore.currentUser?.role === 'OPERATOR'
        )
      ) {
        return <>"Sorry, you aren't allowed to view this page"</>;
      }
    } else {
      return <PlainLoadingSpinner style={{ margin: '50px auto' }} />;
    }
  }

  return (
    <MainLayout limitItemWidths>
      <style>
        {`
          .hackHeadingTextAlign h1,
          .hackHeadingTextAlign h2,
          .hackHeadingTextAlign h3,
          .hackHeadingTextAlign h4 {
            /* The global styles of the site force all headings to be centered. There is no elegant way to override
            this without breaking the existing site. Additionally, responsive layouts may require headings to be centered
            on mobile, but not desktop, etc. Individual pages have to provide their own alignment to override it
            appropriately. The design system page does it here:*/
            text-align: left;
          }
          `}
      </style>
      <div
        className={`daymadeTypographyReset${isFullPagePreview ? '' : ' hackHeadingTextAlign'}`}
      >
        {!isDesignSystemIndex && (
          <AboutUsModule background="white" withNoTopPadding withReducedPadding>
            <AboutUsSiteContainer>
              <Link
                className="linkReset textDecorationUnderline aboutUsTypographyCaption"
                href="/design-system"
              >
                &lt; Back to the design system index
              </Link>
            </AboutUsSiteContainer>
          </AboutUsModule>
        )}
        {props.children}
      </div>
    </MainLayout>
  );
});

export default DesignSystemWrapper;
